"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ConfigurationType;
(function (ConfigurationType) {
    ConfigurationType["provider"] = "provider";
    ConfigurationType["request"] = "request";
})(ConfigurationType = exports.ConfigurationType || (exports.ConfigurationType = {}));
//# sourceMappingURL=ConfigurationType.js.map